import dictionary from '../../../assets/public/i18n/AC/GB/en/en.json';
import { TFunction } from 'next-i18next';

const translateMock: TFunction = (key: string, options?: {}): string => {
    // @ts-ignore
    return dictionary[key] || 'Missing translation for key ' + key;
};

export { translateMock };
